export const ChevronUpIcon = () => (
  <svg className="mc-icon-svg" xmlns="http://www.w3.org/2000/svg" width="31px" height="10px" viewBox="0 0 31 10">
    <path fill="#fff" d="M15.5,0l15.008,9.368L29.493,10L15.5,1.266L1.506,10L0.492,9.367l13.994-8.735h0L15.5,0z" />
  </svg>
);
